import { buildApiUrl } from '../../config/env';

export interface EstimatePoint {
  lat: number;
  lng: number;
  address: string;
}

export interface PublicFareEstimateOption {
  vehicleType: string;
  displayName: string;
  capacityKg: number | null;
  estimated_fare: number;
}

export interface PublicFareEstimateResponse {
  currency: string;
  distanceKm: number;
  durationSec: number;
  routePolyline?: string | null;
  estimates: PublicFareEstimateOption[];
  bookingAvailableInApp: boolean;
  estimate_only: boolean;
}

export interface PublicFareEstimateRequest {
  pickup: EstimatePoint;
  dropoff: EstimatePoint;
}

export async function fetchPublicFareEstimate(
  payload: PublicFareEstimateRequest,
): Promise<PublicFareEstimateResponse> {
  const response = await fetch(buildApiUrl('driver-management/api/public/fare-estimates'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error('Could not calculate this route estimate right now.');
  }

  return response.json();
}
